// _services/liveService.js
import api from '../../../api/axios';

export const liveService = {
  /**
   * Obtener resultados/tiempos
   */
  getResultados: async (slug) => {
    const response = await api.get(`/tiempos/${slug}`);
    return response.data;
  },

  /**
   * Guardar categorías configuradas
   */
  saveCategorias: async (slug, categorias, token) => {
    const response = await api.post(
      `/tiempos/categorias/${slug}`,
      { categorias },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    );
    return response.data;
  },

  /**
   * Subir PDF de resultados
   */
  uploadPdf: async (slug, pdfFile, token) => {
    const formData = new FormData();
    formData.append('pdf', pdfFile);

    const response = await api.post(
      `/tiempos/upload/${slug}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  },

  /**
   * Verificar si usuario es admin
   */
  isAdmin: (userRole) => {
    return userRole === 'Administrador' || userRole === 'Superadministrador';
  },

  /**
   * Obtener rol del localStorage
   */
  getUserRole: () => {
    return localStorage.getItem('role') || localStorage.getItem('userRole');
  },

  /**
   * Obtener token del localStorage
   */
  getToken: () => {
    return localStorage.getItem('token');
  }
};